<template>
  <div class="uni-detail__wrp">
    <subpage-header :page-info="pageInfo" :hide-shapes="true">
      <div slot="title">
        <span class="color-light-green">Yurtlara  </span>Özel İlanlar
      </div>
      <div class="request-right" slot="right">
        <img src="@/assets/img/blog-shape.svg" alt="yurtlarburda blog" class="blog-header__shape">
      </div>
    </subpage-header>
    <div class="subpage__inner uni-detail__inner">
      <SubpageNav :links="links" class="DesktopTab"/>
      <div class="mobileTab">
        <select-box :options="linkMobile" title="Alım Talepleri"/>
      </div>
      <div class="city-list__inner">
        <container>
          <div class="city-list-result">
            <div class="result-bracket">
              <div class="result-bracket__title">
                <span class="result-bracket__count">{{notices.length}}</span> Alım Talebi Bulundu !
              </div>
            </div>
          </div>

          <div class="notice-wrapper">
            <div class="notice-box" v-for="(notice ,index) in notices" :key="notice.id"
                 @click="openBox(notice,index)">

              <div class="notice-box__left">
                <img class="notice-box__left--img" :src="notice.img" alt="">
                <div class="notice-box__left-name">
                 <span class="notice-box__left-name__icon">
                    <svg-icon type="icon-headphone"/>
                  </span>
                  <a href="tel:02232323">
                    {{ notice.owner }}
                  </a>
                </div>
              </div>
              <div class="notice-box__right">
                <p class="notice-box__right-location">{{ notice.location }}</p>
                <p class="notice-box__right-name">{{ notice.detail }}</p>

                <div class="price-gen">
                  <div class="notice-box__right-price">{{ notice.price }} TL</div>
                  <div class="notice-box__right-small">'den başlayan <br> oda fiyatları</div>
                </div>
              </div>
            </div>
          </div>

          <transition name="fade">
            <NoticeLightBox
              v-if="display"
              :active="display"
              :data="lightboxData"
              @onClickNext="nextNotice"
              @onClickPrev="prevNotice"
              :index="IndexNo"
              @closeLightBox="closeBox"
              :is-end="IndexNo === notices.length - 1"
              :is-begin="IndexNo === 0"
            />
          </transition>

        </container>
      </div>
    </div>

  </div>
</template>

<script>
import SubpageHeader from '@/components/SubpageHeader'
import SubpageNav from '@/components/SubpageNav'
import NoticeLightBox from '@/components/Notices/NoticeLightBox.vue'
import SelectBox from '@/components/SelectBox'

export default {
  name: 'Notice',
  components: {
    SubpageHeader, SubpageNav, NoticeLightBox, SelectBox
  },
   metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Ads for DVD',
      link: [
        { rel: 'canonical' },
        { href: window.location.origin + '/ilanlar/alim-talepleri' }
      ]      
    }
  },
  data () {
    return {
      display: false,
      lightboxData: {},
      IndexNo: null,
      pageInfo: {
        title: '<span class="color-light-green">Yurtlara  </span>Özel İlanlar',
        text: 'Baskentler baskenti olarak bilinen, önce Roma, ardindan Dogu Roma (Bizans) Imparatorlugu\n' +
            've kitalara hükmederek büyük baris cografyalari yaratmis.',
        img: null
      },
      uniInfo: {
        logo: require('@/assets/img/uni-logo/Baskent-Universitesi.jpg'),
        site: 'www.iyte.edu.tr'
      },
      links: [
        {
          id: 0,
          title: 'Purchase Requests',
          to: '/advertisements/purchase-requests'
        },
        {
          id: 1,
          title: 'Staff Seekers',
          to: '/advertisements/staff-seekers'
        },
        {
          id: 2,
          title: 'Tools',
          to: '/advertisements'
        },
        {
          id: 3,
          title: 'Collectible Ads',
          to: '/advertisements/collectible-ads'
        },
        {
          id: 4,
          title: 'İş Arayanlar',
          to: '/advertisements/is-arayanlar'
        },
        {
          id: 5,
          title: 'DVD for Sale',
          to: '/advertisements/dvd for sale'
        },
        {
          id: 6,
          title: 'Movie for Rent',
          to: '/advertisements/movie-for-rent'
        }
      ],
      linkMobile: [
        {
          name: 'Purchase Requests'
        },
        {
          name: 'Staff Seekers'
        },
        {
          name: 'Tools'
        },
        {
          name: 'Collectible Ads'
        },
        {
          name: 'Job Seekers'
        },
        {
          name: 'DVD for Sale'
        },
        {
          name: 'Movie for Rent'
        }

      ],
      gallery: [
        {
          id: 0,
          img: require('@/assets/img/sehir-galeri/5.jpg')
        },
        {
          id: 1,
          img: require('@/assets/img/sehir-galeri/1.jpg')
        },
        {
          id: 2,
          img: require('@/assets/img/sehir-galeri/2.jpg')
        },
        {
          id: 3,
          img: require('@/assets/img/sehir-galeri/3.jpg')
        },
        {
          id: 4,
          img: require('@/assets/img/sehir-galeri/4.jpg')
        }
      ],
      notices: [
        {
          id: 0,
          img: require('@/assets/img/view.jpg'),
          location: 'Pendik, İstanbul',
          detail: 'Kocaeli Renault Master Van 2,5 DCI',
          price: 290,
          owner: 'Şahin Zaybak',
          tel: '0539 506 69 51',
          text: 'İstanbul 1 \'in en şirin ilçesi Kartal Cevizli’ de güven, konfor ,5 yıldızlı otel rahatlığını yaşayacağınız Residence dairelerimizi hizmetinize sunuyoruz.Residence binamız T.C.Bayındırlık Bakanlığı standartları, deprem ve yangın yönetmeliklerine göre projelendirilmiştir.'
        },
        {
          id: 1,
          img: require('@/assets/img/view.jpg'),
          location: 'Kocaeli',
          detail: 'Kocaeli Renault Master Van 2,5 DCI',
          price: 120,
          owner: 'Muhammed Erdem',
          tel: '0539 306 49 51',
          text: 'İstanbul 2 \'nin en şirin ilçesi Kartal Cevizli’ de güven, konfor ,5 yıldızlı otel rahatlığını yaşayacağınız Residence dairelerimizi hizmetinize sunuyoruz.Residence binamız T.C.Bayındırlık Bakanlığı standartları, deprem ve yangın yönetmeliklerine göre projelendirilmiştir.'
        },
        {
          id: 3,
          img: require('@/assets/img/view.jpg'),
          location: 'Ankara',
          detail: 'Ankara Renault Master Van 2,5 DCI',
          price: 450,
          owner: 'Mazlum Yıldırım',
          tel: '0532 106 59 11',
          text: 'İstanbul 3 \'ün en şirin ilçesi Kartal Cevizli’ de güven, konfor ,5 yıldızlı otel rahatlığını yaşayacağınız Residence dairelerimizi hizmetinize sunuyoruz.Residence binamız T.C.Bayındırlık Bakanlığı standartları, deprem ve yangın yönetmeliklerine göre projelendirilmiştir.'
        }

      ]
    }
  },
  methods: {
    openBox (item, index) {
      this.display = true
      this.lightboxData = item
      this.IndexNo = index
    },
    closeBox () {
      this.display = false
      this.lightboxData = []
    },
    nextNotice () {
      this.lightboxData = []
      this.IndexNo++
      this.lightboxData = this.notices[this.IndexNo]
    },

    prevNotice () {
      this.lightboxData = []
      this.IndexNo--
      this.lightboxData = this.notices[ this.IndexNo ]
    }
  },
  created () {
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/notice";

</style>
